import { Archive, Lock } from 'lucide-react';
import Card from '../ui/Card';

export default function ArchivedProject({ project }) {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-secondary-800 rounded-full mb-4">
            <Archive className="text-secondary-400" size={40} />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            Projet Archivé
          </h1>
          <p className="text-secondary-200">
            {project.title}
          </p>
        </div>

        {/* Message */}
        <Card padding="lg">
          <div className="text-center space-y-4">
            <div className="flex items-center justify-center gap-2 text-secondary-300">
              <Lock size={20} />
              <span className="font-semibold">Accès restreint</span>
            </div>

            <p className="text-secondary-200">
              Ce projet a été archivé et n'est plus accessible.
            </p>

            {project.archiveReason && (
              <div className="bg-secondary-800 rounded-lg p-4 mt-4">
                <p className="text-sm text-secondary-400">
                  <span className="font-semibold">Raison :</span> {project.archiveReason}
                </p>
              </div>
            )}

            <div className="pt-6 border-t border-secondary-700 mt-6">
              <p className="text-sm text-secondary-400">
                Merci de votre intérêt pour nos services.
              </p>
            </div>
          </div>
        </Card>

        {/* Contact */}
        <div className="text-center mt-6">
          <p className="text-sm text-secondary-400 mb-2">
            Une question ?
          </p>
          <a
            href="mailto:contact@patrick-sanchez.fr"
            className="text-primary-400 hover:text-primary-300 transition underline"
          >
            contact@patrick-sanchez.fr
          </a>
        </div>
      </div>
    </div>
  );
}
